var _defs, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwaitingStreamJa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460 265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.24;}.cls-2{opacity:.35;}.cls-3{fill:#999;font-size:22px;}.cls-4,.cls-5,.cls-6{font-family:KozGoPr6N-Regular-90ms-RKSJ-H, 'Kozuka Gothic Pr6N';}.cls-7{font-family:MyriadPro-Regular, 'Myriad Pro';}.cls-5{letter-spacing:-.05em;}.cls-8{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:4.08px;}.cls-6{letter-spacing:-.03em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.96,58.05c-2.64,0-4.78,2.14-4.78,4.78v7.54c0,13.19,10.7,23.89,23.89,23.89s23.89-10.7,23.89-23.89v-7.54c0-2.64-2.14-4.78-4.78-4.78h-38.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.96,129.72c-2.64,0-4.78-2.14-4.78-4.78h0v-7.54c0-13.19,10.7-23.89,23.89-23.89s23.89,10.7,23.89,23.89v7.54c0,2.64-2.14,4.78-4.78,4.78h-38.22Zm-1.67-47.78h41.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M259.92,129.39c-4.09-8.59-11.9-16.39-20.86-16.39s-16.77,7.81-20.86,16.39"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(155.43 177.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 4.66,
    y: 0
  }, "\u6620\u50CF\u306E\u53D7\u4FE1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 114.66,
    y: 0
  }, "\u5F85"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 135.56,
    y: 0
  }, "\u3061"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingStreamJa);
export default __webpack_public_path__ + "static/media/awaiting_stream_ja.4e8b3472.svg";
export { ForwardRef as ReactComponent };